export const SET_HORIZONTAL_GRAPH_LEGEND =
  'SET_HORIZONTAL_GRAPH_LEGEND';

export const setHorizontalGraphLegend = (
  horizontalGraphLegend: any[],
) => ({
  type: SET_HORIZONTAL_GRAPH_LEGEND,
  data: horizontalGraphLegend,
});
